import React from "react";
import { FONTSIZE } from "../../constants";
import { User } from "../../types";
import useThemeHook from "../hooks/useThemeHook";
import { useTranslationHook } from "../hooks/useTranslationHook";
import { THEME_COLORS } from "../themes/DarkLight";
import emitter, { EmitterEvents } from "../utils/eventsEmitter";
import SectionTitle from "./SectionTitle";
import Text from "./ThemedText";

export const UserCard = ({ user }: { user: User }) => {
  const handleClick = () => {
    console.log("User clicked:", user);
  };

  return (
    <div
      onClick={handleClick}
      className="w-5/12 rounded-2xl p-4 bg-transparent border border-gray-200 flex flex-col items-center justify-center cursor-pointer hover:shadow-md transition-shadow min-h-44"
    >
      <img
        alt={user?.username}
        src={
          user?.profileImage ??
         ( "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
         )}
        className="h-32 w-32 rounded-xl object-cover bg-gray-200 mb-3"
      />
      <p className="text-base font-medium text-gray-900">{user?.username}</p>
      <p className="text-sm text-gray-600">
        {user?.arthereumBalance} Arthereum
      </p>
    </div>
  );
};

const CryptoAssetsSection = ({
  referrals = [],
  onSeeMore,
}: {
  referrals: User[];
  onSeeMore?: Function;
}) => {
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();

  return (
    <div className="mt-5">
      <div className="flex flex-row gap-2.5 items-center justify-between mb-4 px-2.5 w-full">
        <SectionTitle text={getTranslationText("friends_you_invited")} />
        <button
          onClick={() => onSeeMore?.()}
          className="text-sm font-medium text-blue-600 hover:text-blue-700"
        >
          {getTranslationText("see_more")}
        </button>
      </div>
      <div className="flex flex-wrap gap-2.5">
        {referrals.map((referral) => (
          <UserCard key={referral.id} user={referral} />
        ))}
      </div>
    </div>
  );
};

export default CryptoAssetsSection;
